import { useEffect } from "react";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import OfflineExporting from "highcharts/modules/offline-exporting";
import { adicionarGrafico } from "./useGraficosDashboard";

Exporting(Highcharts);
ExportData(Highcharts);
OfflineExporting(Highcharts);

const defaults = {
  chart: {
    type: "pie",
    spacingTop: 20,
  },
  legend: {
    align: "right",
    verticalAlign: "top",
    itemMarginBottom: 25,
  },
  title: {
    text: "",
  },
  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: "Quantidade",
    },
  },
  plotOptions: {
    column: {
      stacking: "normal",
    },
  },
  credits: {
    enabled: false,
    text: "",
  },
  exporting: {
    enabled: false,
  },
};

function useHighchart(id, options, periodo, periodoGlobal, cardId, nomeCard, filtroAplicado) {
  useEffect(
    () => {
      const elemento = document.getElementById(id);
      if (!elemento || elemento.highchartsChart) {
        adicionarGrafico(cardId, undefined, periodo, periodoGlobal, nomeCard, filtroAplicado);
        return;
      }

      const grafico = Highcharts.chart(id, {
        ...defaults,
        ...options,
      });

      adicionarGrafico(cardId, grafico, periodo, periodoGlobal, nomeCard, filtroAplicado);
    },
    [id, options, periodoGlobal]
  );
}

export default useHighchart;
